export default "__VITE_ASSET__CdGR2Kg4__"